module.exports = __webpack_public_path__ + "img/5.fd328939.png";